import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationCoordinates } from '../../model/LocationCoordinates';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  
  constructor() {}

  public async getCurrentLocationAsync(): Promise<LocationCoordinates> {
    return new Promise<LocationCoordinates>((resolve, reject) =>{
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          position => {
            localStorage.setItem('locationPermissionAllowed', 'true');
            localStorage.setItem('currentLocation', JSON.stringify({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }));

            resolve(new LocationCoordinates(
              position.coords.latitude,
              position.coords.longitude
            ));
          },
          error => {
            // Handle network provider errors gracefully
            if (error.code === error.PERMISSION_DENIED) {
              localStorage.setItem('locationPermissionAllowed', 'false');
            }
            reject('Error code' + error.code + ' - ' + error.message);
          }
        );
      }
      else {
        reject('Geolocation not supported');
      }
    }); 
  }

  public getCurrentLocation(): Observable<LocationCoordinates> {
    return new Observable<LocationCoordinates>((observer) => {
      try {
        if ('geolocation' in navigator) {
          const options: PositionOptions = {
            timeout: 3000 // timeout in milliseconds (e.g., 10 seconds)
          };
          navigator.geolocation.getCurrentPosition(
            position => {
              alert("Geolocation response: " + JSON.stringify(position));
              observer.next(new LocationCoordinates(
                position.coords.latitude,
                position.coords.longitude
              ));
              observer.complete();
            },
            error => {
              // Handle network provider errors gracefully
              if (error.code === error.POSITION_UNAVAILABLE) {
                console.error('Location information is unavailable.');
                observer.error('Unable to determine your location. Please check your network or location settings.');
              } else if (error.code === error.PERMISSION_DENIED) {
                console.error('User denied the request for Geolocation.');
                observer.error('Permission to access location was denied.');
              } else if (error.code === error.TIMEOUT) {
                console.error('The request to get user location timed out.');
                observer.error('Location request timed out. Please try again.');
              } else {
                console.error('An unknown error occurred while retrieving location.');
                observer.error('An unknown error occurred while getting location.');
              }
              alert('An error occurred while trying to get the location: ' + error.message);
              throw new Error('Geolocation error: ' + error.message);
            },
            options
          );
        } else {
          alert('Geolocation is not supported.');
          observer.error('Geolocation not supported');
        }
      }
      catch (error) {
        alert('An error occurred while trying to get the location: ' + error);
        observer.error(error);
      }
    });
  }
}
